import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { APP_NAME, LOGO, BLOG_LABEL } from "../../util/brand";
import { BRAND } from "../../brand";
import NewzAgentLogo from "./NewzAgentLogo";
import "../../../apps/public/src/components/Views/Home/Home.css";

const isNewzAgent = BRAND.id === "newzagent";

function MainNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const a = (hash) => isHome ? hash : `/${hash}`;

  const navLinks = isNewzAgent
    ? [
        { href: a("#features"), label: "Features" },
        { href: a("#demo"), label: "Demo" },
        { href: a("#pricing"), label: "Pricing" },
        { href: "/blog", label: BLOG_LABEL, internal: true },
      ]
    : [
        { href: a("#features"), label: "Features" },
        { href: a("#personas"), label: "Use Cases" },
        { href: a("#demo"), label: "Demo" },
        { href: a("#pricing"), label: "Pricing" },
        { href: "/blog", label: BLOG_LABEL, internal: true },
      ];

  return (
    <nav className="home-nav">
      <div className="nav-inner">
        <Link to="/" className="logo">
          {isNewzAgent
            ? <NewzAgentLogo height={36} color="#ffffff" accentColor="#ef4444" />
            : <img src={LOGO} alt={APP_NAME} style={{ height: 36, width: "auto" }} />
          }
        </Link>
        <div className="nav-links">
          {navLinks.map((l) =>
            l.external
              ? <a key={l.href} href={l.href} className="nav-link" target="_blank" rel="noreferrer">{l.label}</a>
              : l.internal
              ? <Link key={l.href} to={l.href} className="nav-link">{l.label}</Link>
              : <a key={l.href} href={l.href} className="nav-link">{l.label}</a>
          )}
          <span style={{ display: "inline-block", width: 12 }} />
          <Link to="/login" className="btn-s btn-sm">Sign In</Link>
          <Link to="/register" className="btn-p btn-sm">Start Free Trial</Link>
        </div>
        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Open menu"
        >
          <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
      {menuOpen && (
        <div className="nav-mobile-menu">
          {navLinks.map((l) =>
            l.external
              ? <a key={l.href} href={l.href} className="nav-mobile-link" target="_blank" rel="noreferrer" onClick={() => setMenuOpen(false)}>{l.label}</a>
              : l.internal
              ? <Link key={l.href} to={l.href} className="nav-mobile-link" onClick={() => setMenuOpen(false)}>{l.label}</Link>
              : <a key={l.href} href={l.href} className="nav-mobile-link" onClick={() => setMenuOpen(false)}>{l.label}</a>
          )}
          <Link to="/login" className="nav-mobile-link" onClick={() => setMenuOpen(false)}>Sign In</Link>
          <Link to="/register" className="nav-mobile-link nav-mobile-cta" onClick={() => setMenuOpen(false)}>Start Free Trial</Link>
        </div>
      )}
    </nav>
  );
}

export default MainNav;
